/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/TrendingMenu/theme';

export const TrendingMenuTheme = theme;
